import { useEffect, useMemo, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useSearchParams } from 'react-router-dom'
import Filters from '../../Component/Filters/Filters'
import Button from '../../Component/Input/Button'
import TextInput from '../../Component/Input/TextInput'
import MemberList from '../../Component/MemberList'
import Content from '../Content'
import Footer from '../Footer'
import Header from '../Header'
import Main from '../Main'
import MenuMobile from '../MenuMobile'

function Search() {
  // 1a — the header popup hands off here on Enter, with the query in the URL.
  const [searchParams] = useSearchParams();
  const initialQuery = searchParams.get("q") ?? "";
  const [search, setSearch] = useState(initialQuery)
  const intl = useIntl();

  useEffect(() => {
    const q = searchParams.get("q");
    if (q !== null) setSearch(q);
  }, [searchParams]);

  // A stable identity per query — a fresh object every render would make
  // MemberList refetch in a loop.
  const searchInputs = useMemo(() => ({ text: search }), [search]);

  return (
    <>
      <Header />
      <Content>
        <Main>
          <div className='max-w-5xl w-full mx-auto my-0 flex flex-col gap-8 px-4'>
            <h2 className='text-center text-primary text-2xl'><FormattedMessage id="menu__search" /></h2>
            <Filters />
            <TextInput key={initialQuery} defaultValue={initialQuery} label={intl.formatMessage({id:"search__input_placeholder"})} setValue={setSearch} id="search-input" />
             <Button className="self-center mx-auto" color='primary' name="search__button" onClick={() => {
              setSearch((document.getElementById("search-input") as HTMLInputElement)?.value)
             }}/>
            {search !== "" && <MemberList
              endpoint='search'
              additionalInputs={searchInputs}
            />}
          </div>
        </Main>
      </Content>
      <Footer />
      <MenuMobile />
    </>
    )
}

export default Search
